import { styled } from '@mui/material';
import { Check } from '@phosphor-icons/react';

export const CheckIconStyled = styled(Check)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.common.white,
  fontSize: '1.8rem',
  'input:disabled ~ &': {
    color: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[200],
  },
}));

export const IconStyled = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  border: `0.1rem solid ${theme.palette.primary.main}`,
  borderRadius: theme.shape.borderRadius,
  height: '1.8rem',
  width: '1.8rem',
  'input:disabled ~ &': {
    border: `0.1rem solid ${theme.palette.grey[200]}`,
  },
}));
